import Avatar, { RemovedPersonAvatar } from '@components/Avatar';
import { getInitialsFull } from '@helpers/userName';
import { PulseAiIcon, ReplyIcon } from 'assets/images/icons';

const genericReplyAvatar = (
    <Avatar
        size="large"
        icon={<ReplyIcon />}
        sx={{
            backgroundColor: 'var(--action-hover)',
            '& svg path': {
                fill: 'var(--text-tertiary)',
                fillOpacity: 1,
            },
        }}
    />
);

const pulseAvatar = <Avatar size="large" icon={<PulseAiIcon />} />;

const ReplyAuthorAvatar = ({ isAutoReply, repliedByUserId, fullName, photoUrl, isRemoved }) => {
    if (isAutoReply) {
        return pulseAvatar;
    }

    if (isRemoved) {
        return <RemovedPersonAvatar size="large" />;
    }

    if (repliedByUserId && fullName) {
        return <Avatar size="large" image={photoUrl} label={getInitialsFull(fullName)} fullName={fullName} />;
    }

    return genericReplyAvatar;
};

export default ReplyAuthorAvatar;
